import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingSpinner } from '../../components/Molecules';
import { Theme } from '../../constants/Theme';
import { WebPageType } from '../../constants/webPageType';
import useRedirectHome from '../../hooks/useRedirectHome';
import useRegisterQuery from '../../hooks/useRegisterQuery';
import { TranslationLocale } from '../../i18n';
import { useSessionStore } from '../../stores/SessionStore';
import { getUiLocale } from '../../utils/i18n';

interface TrialScreenProps {
  webPageType: WebPageType;
}

const { register } = useSessionStore.getState();

const TrialScreen: React.FC<TrialScreenProps> = ({ webPageType }) => {
  const { i18n } = useTranslation();
  const { webBoosterType, source } = useRegisterQuery();

  const isLoggedIn = useSessionStore((state) => state.isLoggedIn());

  useRedirectHome(isLoggedIn, webPageType);

  useEffect(() => {
    if (!isLoggedIn) {
      register({
        uiTheme: Theme.Light,
        interfaceLocale: getUiLocale(i18n.language as TranslationLocale),
        webBoosterType,
        source,
      }).catch(console.error);
    }
  }, [i18n.language, isLoggedIn, source, webBoosterType]);

  return (
    <>
      <LoadingSpinner loading={true} />
    </>
  );
};

export default TrialScreen;
